const path = "/remocao/iten-iscricao-distribuicao";
export default {
  main: path,
  inserirChecked: `${path}/insert-checked`,
  remove: (id) => `${path}/${id}`,
};
